import { createSelector } from 'reselect';
import { statusSuccess } from '@grandvisionhq/state';
import { getCheckout } from '../../../../selectors.js';
import { isUninitialized } from '../../../../state.js';
import { getSelectedShippingMethod } from '../../../selectors.js';

const getShippingMethods = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.shippingMethods ? checkout.shippingMethods : undefined
);
const getSelectedShippingMethodId = createSelector(getShippingMethods, getSelectedShippingMethod, (shippingMethodsState, selectedShippingMethod)=>{
    if (!shippingMethodsState || !statusSuccess(shippingMethodsState)) {
        return;
    }
    const shippingMethods = shippingMethodsState.result;
    const shippingMethodData = shippingMethods.find((shippingMethod)=>{
        return shippingMethod.key === (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method);
    });
    return shippingMethodData === null || shippingMethodData === void 0 ? void 0 : shippingMethodData.id;
});

export { getSelectedShippingMethodId, getShippingMethods };
//# sourceMappingURL=selectors.js.map
